import React from "react";
import { ServicePage } from "@/components/ServicePage";
import { SecurityExplainers } from "@/components/explainers/SecurityExplainers";

export const ManagedSecurity = () => (
  <ServicePage
    slotAfterFeatures={<SecurityExplainers />}
    testIdSlug="managed-security"
    seo={{
      title: "Managed Security · UTM Firewall, AV, Mail-Security",
      description: "Managed Security made in Germany: UTM-Firewall, Antivirus, Mail-Security, MDM, Backup und Awareness als ein einziger Managed Service. Ohne Leasing.",
      keywords: "Managed Security, UTM Firewall, Securepoint, Antivirus Unternehmen, Mail Security, MDM, Cyber Awareness, IT-Sicherheit Hessen",
      serviceName: "Managed Security",
      breadcrumb: [
        { name: "Start", path: "/" },
        { name: "Managed Security", path: "/managed-security" },
      ],
    }}
    eyebrow="Managed Security"
    title="Sicherheit, die im Hintergrund arbeitet – damit Sie es nicht müssen."
    subtitle="UTM-Firewall, Antivirus, Mail-Security, MDM, Backup und Awareness – als ein einziger Managed Service. Ohne Leasing, ohne Finanzierung, ohne Überraschungen."
    heroImage="/wp-images/managed-security.jpg"
    features_intro="Sechs Bausteine, ein Schutzschild. Buchen Sie modular oder als Komplettpaket."
    features={[
      {
        title: "UTM Firewall",
        desc: "Securepoint NextGen UTM als Managed Service, 24/7 inkl. Anomalie-Meldungen.",
        points: ["Anti-Spam & Content-Filter", "Doppelter Virenfilter", "VPN für mobile Mitarbeiter"],
      },
      {
        title: "Antivirus Pro",
        desc: "Unternehmens-AV mit Alarmierung im Vollzeitmodus.",
        points: ["Hochleistungsfähige Scan-Engine", "Schnell und unauffällig", "Zentrale Verwaltung"],
      },
      {
        title: "Mail Security",
        desc: "Cloud-basierter Mail-Schutz – auch an Wochenenden und Feiertagen.",
        points: ["Top-Erkennungsrate", "Mehrstufige Analyse", "Quarantäne & Tagging"],
      },
      {
        title: "Mobile Device Management",
        desc: "Sicher Mobilgeräte zentral steuern – Android und Apple.",
        points: ["Kontrolle über Apps & Rechte", "BYOD-fähig", "Remote Wipe & Lock"],
      },
      {
        title: "Unified Backup",
        desc: "Datensicherung auf Höchstniveau – der letzte Schutz vor Ransomware.",
        points: ["Air-Gap Architektur", "Server in Deutschland", "Active Protection"],
      },
      {
        title: "Awareness PLUS",
        desc: "Mitarbeitende werden zur 'Human Firewall'.",
        points: ["Regelmäßige Trainings", "Phishing-Simulationen", "Messbarer Lernerfolg"],
      },
    ]}
    longText={[
      "<strong>Managed Security Services (MSS)</strong> von IT-Servicepoint bieten Unternehmen eine umfassende Lösung zur Sicherstellung ihrer IT-Sicherheit. Durch die Auslagerung von Sicherheitsfunktionen an unsere erfahrenen Spezialisten profitieren Sie von Fachwissen und modernster Technologie – ohne eigene Ressourcen aufbauen zu müssen.",
      "Unsere MSS umfassen 24/7-Netzwerküberwachung, Bedrohungserkennung, Incident Response und Compliance-Management. Wir analysieren kontinuierlich Daten und identifizieren potenzielle Bedrohungen, bevor sie zu Problemen werden.",
      "Regelmäßige Sicherheitsbewertungen und Audits gehören zum Angebot – damit Schwachstellen identifiziert und behoben werden, bevor sie ausgenutzt werden können. <strong>Managed Security made in Germany.</strong>",
    ]}
  />
);
